
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/to-rent/[...search-path]",
      function () {
        return require("private-next-pages/to-rent/[...search-path]/index.tsx");
      }
    ]);
  